module.exports = __webpack_public_path__ + "img/icon-footer-tel-dark.9fa64d1d.svg";